import React, {Component, Fragment} from "react";
import SimpleInput from "../../../../modules/SimpleInput";
import {attributesInput} from "./config";
import withFormGroup from "../../../../modules/commons/withFormGroup";
import FlexView from "react-flexview";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import {flattenFormGroupObject} from "../../../common/mapper";
import * as R from "ramda";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";
import {generateSaveAlertContent} from "./util";
import SimpleCamera from "../../../../modules/SimpleCamera";

class OnSamsatDetailInputModifying extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isCorrection: false,
            alertModalSaveVisible: false,
            errorTaxSheetTentativeCost: null
        }
    }

    componentDidMount() { 
        this.resetValueProcessId(this.props.tab);
     }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.dataDetail !== prevProps.dataDetail) {
            this.resetValueProcessId(this.props.tab);
        }
    }

    resetValueProcessId = (activeTab) => {
        console.log("here");
        let {stnk, taxSheets, platNumber, bpkb} = this.props.dataDetail;
        console.log(this.props.dataDetail);
        switch (activeTab) {
            case "stnk":
                console.log("stnk");
                this.props.setValue("processSamsatSTNKId", stnk.processSamsatSTNKId);
                return;
            case "taxSheets":
                console.log("taxSheets");
                this.props.setValue("processSamsatPajakId", taxSheets.processSamsatPajakId);
                return;
            case "platNumber":
                console.log("platNumber");
                this.props.setValue("processSamsatPlatId", platNumber.processSamsatPlatId);
                return;
            case "bpkb":
                console.log("bpkb");
                this.props.setValue("processSamsatBPKBId", bpkb.processSamsatBPKBId);
                return;
            default :
                return;
        }
    }

    handleCorrection = () => {
        this.setState((prevState) => ({
            ...prevState,
            isCorrection: !prevState.isCorrection,
        }));
    }

    handleAlertModalSaveVisibility = () => {
        this.setState((prevState) => ({
            ...prevState,
            alertModalSaveVisible: !prevState.alertModalSaveVisible,
        }));
    }

    modifyFormGroup = (data) =>{
        if(this.props.tab === 'taxSheets'){
            const { fjOtherCost , ...rest } = data
            return rest
        }
        return data;
    }

    handleSubmit = () => {
        if (this.props.validate()) {
            this.handleAlertModalSaveVisibility();
            const formGroup = this.modifyFormGroup(flattenFormGroupObject(this.props.controls));
            this.props.onSubmit(formGroup);
            this.handleCorrection()
        }
    }

    getErrorMessage = (data) => {
        return Object.entries(data).map(([key, {value}]) => {
            if (this.props.formGroup[key]?.mandatory && (R.isEmpty(value) || R.isNil(value))) {
                return {
                    key,
                    errorMessage: "Field belum diisi",
                };
            }
            return null
        }).filter(Boolean);
    }

    validateTaxSheetOtherCost = () => {
        if(this.props.tab !== 'taxSheets') return true
        
        const otherCost = Number(this.props.controls.otherCost?.value);
        const tentativeFj = this.props.dataDetail?.samsatPajakResponseDTO?.tentativeFj;
        
        if (tentativeFj) {
          if (otherCost === 0) {
            this.setState({ errorTaxSheetTentativeCost: 'Field Belum Diisi' });
            return false;
          }
          this.setState({ errorTaxSheetTentativeCost: null });
          return true
        }
        
        return true;
    };

    render() {
        console.log(this.props,'attributesInput')
        return (
            <Fragment>
                <div className="grid grid-2x gap-20px grid-mobile-none">
                    <div id="grid-1">
                        {
                            attributesInput[this.props.tab].firstGrid.map((attribute, index) => {
                                const isPajakProgresifPrice = R.equals(attribute.name, "pajakProgresifPrice");
                                const isOtherCost = R.equals(attribute.name, "otherCost");
                                const isTentative = this.props.dataDetail?.samsatPajakResponseDTO?.tentativeFj
                                
                                if (isPajakProgresifPrice || isOtherCost) {
                                    return (
                                        <SimpleInput
                                            key={index}
                                            box="number"
                                            id={`input_text_${attribute}`}
                                            // mandatory={this.props.formGroup[attribute.name]?.mandatory}
                                            mandatory={
                                              isOtherCost
                                                ? isTentative
                                                : this.props.formGroup[attribute.name]?.mandatory
                                            }
                                            name={attribute.name}
                                            label={attribute.label}
                                            errorMessage={isOtherCost ? this.state.errorTaxSheetTentativeCost : this.props.errors[attribute.name]}
                                            readOnly={
                                              this.state.isCorrection
                                                ? (isOtherCost && (!isTentative || isTentative === null)
                                                    ? true
                                                    : !attribute.correctionAble)
                                                : true
                                            }
                                            value={this.props.controls[attribute.name]?.value}
                                            onValueChange={({value}) => this.props.setValue(attribute.name, String(value))}
                                        />
                                    )
                                }
                                return (
                                    <SimpleInput
                                        key={index}
                                        id={`input_text_${attribute}`}
                                        mandatory={this.props.formGroup[attribute.name]?.mandatory}
                                        name={attribute.name}
                                        label={attribute.label}
                                        errorMessage={this.props.errors[attribute.name]}
                                        readOnly={R.equals(this.state.isCorrection, true) ? !attribute.correctionAble : true}
                                        value={this.props.controls[attribute.name]?.value}
                                        onChange={({target}) => this.props.setValue(target.name, target.value)}
                                    />
                                )
                            })
                        }
                    </div>
                    <div id="grid-2">
                        {
                            attributesInput[this.props.tab].secondGrid.map((attribute) => {
                                return (
                                    <SimpleCamera
                                        key={`upload_file_${this.state.activeTab}`}
                                        id={`input_file_${this.state.activeTab}`}
                                        mandatory={this.props.formGroup[attribute.name]?.mandatory}
                                        disabled={R.equals(this.state.isCorrection, true) ? !attribute.correctionAble : true}
                                        name={attribute.name}
                                        label={attribute.label}
                                        errorMessage={this.props.errors[attribute.name]}
                                        enableUpload={true}
                                        value={this.props.controls[attribute.name]?.value}
                                        onChange={(value, name) => this.props.setValue(name, value)}
                                    />
                                )
                            })
                        }
                    </div>
                </div>

                <div style={{textAlign: "right", marginTop: "20px"}}>
                    <FlexView hAlignContent={"right"}>
                        <SimpleButton
                            id={`button_${this.props.tab}_correction`}
                            type="button"
                            text="Koreksi"
                            onClick={() => this.handleCorrection()}
                        />
                        <SimpleButton
                            id={`button_${this.props.tab}_save`}
                            type="button"
                            text="Simpan"
                            onClick={() => {
                                if (this.props.validate() && this.validateTaxSheetOtherCost()) {
                                    this.handleAlertModalSaveVisibility();
                                } else {
                                    const error = this.getErrorMessage(this.props.controls);
                                    this.props.setError(error);
                                }
                            }}
                        />
                    </FlexView>

                </div>


                {this.state.alertModalSaveVisible && (
                    <SimpleAlert
                        title={"Information"}
                        content={generateSaveAlertContent(this.props.tab, this.props.dataDetail, this.props.controls)}
                        visible={this.state.alertModalSaveVisible}
                        onClickClose={this.handleAlertModalSaveVisibility}
                        additionalButtons={
                            <FlexView>
                                <SimpleButton
                                    secondary
                                    type="button"
                                    text="Batal"
                                    onClick={() => this.handleAlertModalSaveVisibility()}
                                />
                                <SimpleButton
                                    type="button"
                                    text="OK"
                                    onClick={() => this.handleSubmit()}
                                />
                            </FlexView>
                        }
                    />
                )}
            </Fragment>
        )
    }
}

export default withFormGroup(OnSamsatDetailInputModifying);